export const formatHumidity = (value: number) => value.toFixed(2);
